const blankResourceDayType = {
  date:'',
  dayType: null,
  allDayTypes: true,
  comment: '',
  myComment: '',
  tkComment: '',
};

export default blankResourceDayType;



// WEBPACK FOOTER //
// ./src/Components/DayType/utils/day-type-requests/blankResourceDayType.js